export class LoginPeticion {
    public docEmpresa: string = "-1";
    public docUsuario: string = "-1";
    public claveUsuario: string = "-1";
    public codCliente: string = "-1";
    public codTpoPortal: string = "-1";
    public cierraOtraSesion: string = 'N';
}